var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavIconSettings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nav-icon-settings",
    transform: "translate(-140 -393)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5670",
    "data-name": "Rectangle 5670",
    width: 34,
    height: 34,
    transform: "translate(140 393)",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6981",
    "data-name": "Group 6981",
    transform: "translate(115.076 -145.33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60",
    transform: "translate(-3564.906 -111.016)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M20.842,246.539a11.252,11.252,0,0,1,2.925,1.214l.922-.923a1.89,1.89,0,0,1,2.674,0l1.336,1.336a1.89,1.89,0,0,1,0,2.674l-.923.923a11.246,11.246,0,0,1,1.214,2.924h1.3a1.89,1.89,0,0,1,1.89,1.89v1.891a1.89,1.89,0,0,1-1.89,1.89h-1.3a11.246,11.246,0,0,1-1.214,2.924l.923.923a1.889,1.889,0,0,1,0,2.673l-1.336,1.337a1.89,1.89,0,0,1-2.674,0l-.922-.923a11.286,11.286,0,0,1-2.925,1.214v1.3a1.89,1.89,0,0,1-1.89,1.89h-1.89a1.891,1.891,0,0,1-1.891-1.89v-1.3a11.28,11.28,0,0,1-2.924-1.214l-.923.923a1.889,1.889,0,0,1-2.673,0l-1.337-1.337a1.892,1.892,0,0,1,0-2.673c.489-.488.923-.923.923-.923a11.315,11.315,0,0,1-1.214-2.924h-1.3a1.891,1.891,0,0,1-1.891-1.89v-1.891a1.891,1.891,0,0,1,1.891-1.89h1.3a11.315,11.315,0,0,1,1.214-2.924l-.923-.923a1.893,1.893,0,0,1,0-2.674l1.337-1.336a1.889,1.889,0,0,1,2.673,0l.923.923a11.246,11.246,0,0,1,2.924-1.214v-1.3a1.891,1.891,0,0,1,1.891-1.89h1.89a1.89,1.89,0,0,1,1.89,1.89Z",
    transform: "translate(3589 409)",
    fill: "none",
    stroke: "#d1cedc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M18.007,251.852a5.67,5.67,0,1,1-5.671,5.671A5.674,5.674,0,0,1,18.007,251.852Z",
    transform: "translate(3589 409)",
    fill: "none",
    stroke: "#d1cedc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIconSettings);
export default __webpack_public_path__ + "static/media/nav-icon-settings.6d1012390914929046bc2911e1d0b952.svg";
export { ForwardRef as ReactComponent };